/** Closed conversation-picker label — an absent segment (and its separator) is omitted when blank. */
export const buildConversationLabel = (code?: string, subject?: string, company?: string): string => {
  const head = [code, subject].filter(Boolean).join(' - ')
  return [head, company ? `(${company})` : undefined].filter(Boolean).join(' ')
}
